import React from 'react';
import { Helmet } from 'react-helmet-async';
import YouTubeHero from '../components/YouTubeHero';
import YouTubeTagGenerator from '../components/YouTubeTagGenerator';
import YouTubeFeatures from '../components/YouTubeFeatures';
import YouTubeHowItWorks from '../components/YouTubeHowItWorks';
import YouTubeTestimonials from '../components/YouTubeTestimonials';
import YouTubeGuide from '../components/YouTubeGuide';
import YouTubeSEOContent from '../components/YouTubeSEOContent';
import YouTubeFAQ from '../components/YouTubeFAQ';
import YouTubeCallToAction from '../components/YouTubeCallToAction';

export default function YouTubeTagPage() {
  return (
    <>
      <Helmet>
        <title>YouTube Tag Generator | Create Optimized Video Tags</title>
      </Helmet>
      <YouTubeHero />
      <YouTubeTagGenerator />
      <YouTubeFeatures />
      <YouTubeHowItWorks />
      <YouTubeTestimonials />
      <YouTubeGuide />
      <YouTubeSEOContent />
      <YouTubeFAQ />
      <YouTubeCallToAction />
    </>
  );
}